import React from "react";
import PropTypes from "prop-types";

import { Placeholder, Table } from "semantic-ui-react";

function ImportedSyncEntityTable({ loading, columns, rows }) {
  if (loading) {
    return (
      <Placeholder data-test="import-sync-entity-table-placeholder">
        <Placeholder.Header>
          <Placeholder.Line />
          <Placeholder.Line />
        </Placeholder.Header>
      </Placeholder>
    );
  }

  return (
    <Table data-test="import-sync-entity-table">
      <Table.Header>
        <Table.Row>
          {columns.map(({ id, title }) => {
            return <Table.HeaderCell key={id}>{title}</Table.HeaderCell>;
          })}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rows.map(({ externalId, name, count, isExcluded }) => {
          const style = isExcluded ? { color: "grey" } : {};
          return (
            <Table.Row key={externalId}>
              <Table.Cell
                data-test="imported-sync-entity-row-name"
                style={style}
              >
                {name}
              </Table.Cell>
              <Table.Cell
                data-test="imported-sync-entity-row-count"
                style={style}
              >
                {isExcluded ? "-" : count}
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
}

ImportedSyncEntityTable.propTypes = {
  loading: PropTypes.bool,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string,
      name: PropTypes.string,
      count: PropTypes.number,
      isExcluded: PropTypes.bool,
    })
  ),
};

ImportedSyncEntityTable.defaultProps = {
  loading: false,
  columns: [],
  rows: [],
};

export default ImportedSyncEntityTable;
